"use strict";

angular.module("portal.lookup").controller("FireDrillLookup", [
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "Enterprise",
    "FireDrill",
    function (
        $scope,
        $state,
        $stateParams,
        $rootScope,
        Enterprise,
        FireDrill
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.show_search_results = false;

        $scope.schoolSystems = [];
        $scope.schools = [];
        $scope.years = [];

        $scope.filters = {};

        $scope.fireDrills = [];

        $scope.currentState = $state.current.name;
        if ($stateParams.priorState) {
            $scope.priorState = $stateParams.priorState;
        }

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            $scope.loading = false;
        } else {
            if ($rootScope.userAccount !== null) {
                Enterprise.get($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            } else {
                $scope.parameters.isPortal = true;
                Enterprise.getLess($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            }
        }

        //recaptcha vars
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        FireDrill.getPublicSchoolSystems().then(function (result) {
            if (result != null) {
                $scope.schoolSystems = result;
            }
        });


        $scope.onSystemFilterChange = function () {
            $scope.schools = []
            $scope.years = []
            FireDrill.getPublicSchools($scope.filters).then(function (result) {
                if (result != null) {
                    $scope.schools = result;
                }
            });
        }

        $scope.onSchoolFilterChange = function () {
            $scope.years = []
            if (!(isUndefined($scope.filters.SchoolSystemId) || isUndefined($scope.filters.SchoolId))) {
                FireDrill.getPublicYears($scope.filters).then(function (result) {
                    if (result != null) {
                        var yearObjs = []
                        for (var x in result) {
                            yearObjs.push({ id: result[x], name: result[x] })
                        }
                        $scope.years = yearObjs;
                    }
                });
            }
        }

        $scope.onSystemFilterChange();

        $scope.columns = [
            {
                label: "Drill Date",
                field: "drillDate",
                type: 'date'
            },
            {
                label: "Number of People",
                field: "numOfPeople"
            },
            {
                label: "Response Time",
                field: "responseTime"
            },
            {
                label: "Drill Type",
                field: "drillType"
            }
        ];

        $scope.search = function search() {

            if (isUndefined($scope.filters.SchoolSystemId) || isUndefined($scope.filters.SchoolId)) {
                return;
            }

            $scope.looking_up = true;
            $scope.show_search_results = false;
            FireDrill.getPublicFireDrills($scope.filters).then(function (result) {
                if (result != null) {
                    $scope.fireDrills = result;
                }
                $scope.looking_up = false;
                $scope.show_search_results = true;
            });
        }

        $scope.clearFilter = function () {
            $scope.fireDrills = [];
            $scope.filters = {};
        }

        $scope.recaptchaSubmit = function () {
            $scope.looking_up = true; //if there is a loading type var for display
            if ($scope.enterprise.recaptcha_enabled) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'fireDrillLookup' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("fireDrillLookup", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.looking_up = false; //if there is a loading type var for display
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.search(); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            })
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.looking_up = false; //if there is a loading type var for display
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.search(); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };
    }
]);
